import React from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const TenantPlatform = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="tenant-reason">
        <div className="inner">
          <div className="title">{t("tenant.expend.title")}</div>

          <div className="identify-card-warp">
            <div className="tenant-card-img">
              <img src={t("tenant.expend.img")} alt="authing" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
